export const presetPrompts = {
    "SVG Vector Shape Graphics": [
        "Generate a Star Badge Winner Lower Third with Gold SVG Star",
        "Create a Shield Rank Leaderboard with SVG Shield Badges",
        "Generate a Speech Balloon Graphic with SVG Callout",
        "Create a Crown Leaderboard Badge for Rank #1",
        "Generate an Arrow Direction Score Bug with SVG Arrow",
        "Create a Trophy Champion Full-Screen Graphic with SVG Trophy Badge"
    ],
    "News & Current Affairs": [
        "Create a standard news lower third with a reporter name and location",
        "Generate a TV breaking news ticker for the bottom of the screen",
        "Generate a TV channel LIVE bug for the top right corner",
        "Create a split-screen interview layout for a news channel with 2 frames",
        "Generate a 3-box split screen for a political debate with nameplates",
        "Create a weather forecast side-panel with 5-day outlook",
        "Generate a stock market ticker with green and red percentage changes",
        "Create a 'Coming Up Next' full-screen graphic with title and time",
        "Generate an Election Results lower third showing candidate percentages",
        "Create a 'Breaking News' full-screen alert graphic with a large red header",
        "Generate a financial news sidebar showing currency exchange rates",
        "Create a news channel 'Top Story' corner bug",
        "Generate a poll results bar chart for a morning show",
        "Create a full-screen quotation graphic for a news interview quote"
    ],
    "Football (Soccer)": [
        "Generate a football score bug for MUN vs CHE with clock",
        "Create a football starting lineup full-screen graphic",
        "Generate a football halftime stats comparison board",
        "Create a football substitution lower third graphic",
        "Generate a football penalty shootout tracker graphic"
    ],
    "Cricket": [
        "Generate a cricket score bug for IND vs AUS, 150/2, 20.0 overs",
        "Create a cricket lineup graphic for India",
        "Generate a cricket bowler vs batsman matchup graphic",
        "Create a cricket fall of wickets timeline graphic",
        "Generate a cricket current run rate vs required run rate bug"
    ],
    "Tennis": [
        "Generate a tennis score bug for player A vs player B",
        "Create a tennis match stats full-screen graphic",
        "Generate a tennis serve speed radar pop-up graphic",
        "Create a tennis tournament bracket progression graphic",
        "Generate a tennis 'Set Point' / 'Match Point' flashing alert"
    ],
    "Basketball": [
        "Generate a basketball score bug with shot clock",
        "Create a basketball player stats lower third (points, rebounds, assists)",
        "Generate a basketball starting five full-screen graphic",
        "Create a basketball team fouls and timeouts remaining bug",
        "Generate a basketball quarter-by-quarter score breakdown graphic"
    ],
    "Baseball": [
        "Generate a baseball score bug with bases and inning indicator",
        "Create a baseball batter statistics lower third",
        "Generate a baseball pitcher pitch count and speed graphic",
        "Create a baseball batting order full-screen graphic",
        "Generate a baseball 'Home Run' celebration graphic"
    ],
    "Rugby": [
        "Create a rugby score bug with team colors and clock",
        "Generate a rugby scrum statistics comparison graphic",
        "Create a rugby player yellow/red card lower third",
        "Generate a rugby possession percentage donut chart",
        "Create a rugby try conversion attempt tracker graphic"
    ],
    "Golf": [
        "Create a golf leaderboard showing player names and scores under par",
        "Generate a golf hole layout side-panel with par and yardage",
        "Create a golf player current round scorecard graphic",
        "Generate a golf drive distance and ball speed lower third",
        "Create a golf 'Leader in the Clubhouse' indicator bug"
    ],
    "Swimming": [
        "Generate a swimming race timer and leaderboard for 4 lanes",
        "Create a swimming lane assignment full-screen graphic",
        "Generate a swimming split times comparison graphic",
        "Create a swimming world record vs current pace line indicator",
        "Generate a swimming medal ceremony lower third"
    ],
    "Volleyball": [
        "Create a volleyball scoreboard for team A vs team B, best of 5 sets",
        "Generate a volleyball player spike speed lower third",
        "Create a volleyball team service errors vs aces comparison",
        "Generate a volleyball rotation/lineup graphic",
        "Create a volleyball 'Set Point' flashing corner bug"
    ],
    "Formula 1 & Motorsports": [
        "Create a motorsports/F1 style lap timer and top 3 positions sidebar",
        "Generate a motorsports starting grid full-screen graphic",
        "Create a motorsports current tire compound and age indicator",
        "Generate a motorsports pit stop time tracker graphic",
        "Create a motorsports sector times (purple, green, yellow) lower third"
    ],
    "Entertainment & Talk Shows": [
        "Create a talk show guest lower third with their latest book title",
        "Generate a social media comment pop-up graphic for live Q&A",
        "Create a persistent hashtag bug for the top left corner",
        "Generate a 'Subscribe & Like' lower third for a YouTube livestream",
        "Create a pop-culture trivia question full-screen graphic",
        "Generate an entertainment news 'Exclusive' stamp graphic",
        "Create a music video MTV-style lower third (Artist, Title, Album)",
        "Generate a reality TV confessional lower third with name and age",
        "Create a talent show judge scorecard graphic",
        "Generate an award show 'And the winner is...' split screen graphic"
    ],
    "General Broadcast & Utility": [
        "Create a TV station ID bug (channel logo placeholder)",
        "Generate a parental advisory / age rating bug for the top left",
        "Create a 'Sponsored By' lower third with logo placeholder",
        "Generate a copyright watermark for the bottom right corner",
        "Create a closed captioning (CC) availability indicator graphic",
        "Generate a countdown timer graphic to top of the hour",
        "Create a technical difficulty 'Please Stand By' full-screen graphic",
        "Generate an L-band squeeze back layout for commercials",
        "Create an end-credits scrolling text layout"
    ],
    "Game Shows & Reality TV": [
        "Generate a game show contestant podium nameplate with score",
        "Create a game show 'Fast Money' style countdown timer graphic",
        "Generate a 'Correct Answer' flashing green full-screen graphic",
        "Create an 'Incorrect Answer' red strike-through graphic",
        "Generate a reality TV voting results bar chart",
        "Create a 'Text to Vote' lower third with a phone number and shortcode",
        "Generate a contestant elimination split-screen graphic",
        "Create a 'Prize Reveal' sparkling full-screen graphic",
        "Generate a hidden camera prank show 'Target' indicator graphic",
        "Create a reality dating show 'Rose Ceremony' remaining count bug"
    ],
    "eSports & Gaming": [
        "Generate a League of Legends style champion select overlay",
        "Create a CS:GO style bomb defuse timer graphic",
        "Generate a Fighting Game (FGC) health bar and combo counter overlay",
        "Create a Twitch streamer webcam border with recent subscriber scroll",
        "Generate a battle royale 'Players Remaining' top-right bug",
        "Create an eSports caster desk lower third with twitter handles",
        "Generate an eSports tournament bracket full-screen tree",
        "Create a post-match MVP stats sidebar",
        "Generate a 'Stream Starting Soon' countdown full-screen graphic",
        "Create a live chat overlay bounding box for a livestream"
    ],
    "Home Shopping & Commercials": [
        "Generate a home shopping channel 'Item Details' sidebar with price",
        "Create an 'Only 10 Left in Stock' flashing urgency bug",
        "Generate a toll-free ordering number lower third",
        "Create a 'Before and After' split-screen comparison graphic",
        "Generate a 'Special Offer' corner ribbon graphic",
        "Create a commercial break 'We will be right back' bumper",
        "Generate an infomercial product feature bulleted list",
        "Create a QR code scan prompt graphic for the bottom right",
        "Generate a 'Free Shipping' pop-up promotional bug",
        "Create a 'Call Now' flashing red lower third"
    ],
    "Extreme Sports & Olympics": [
        "Generate a snowboarding halfpipe score and trick sidebar",
        "Create a surfing heat timer and wave score lower third",
        "Generate a skateboarding 'Best Trick' full-screen results graphic",
        "Create an Olympic-style medal tally leaderboard",
        "Generate a gymnastics vault score deduction graphic",
        "Create a marathon runner pace and distance lower third",
        "Generate a track cycling velodrome lap counter",
        "Create an archery target score ring graphic",
        "Generate a weightlifting attempt tracker graphic",
        "Create an equestrian dressage penalty score bug"
    ],
    "Documentaries & Educational": [
        "Generate a documentary style historical date and location lower third",
        "Create a 'Did you know?' educational pop-up graphic",
        "Generate a scientific formula or equation full-screen graphic",
        "Create a nature documentary animal species nameplate",
        "Generate an on-screen glossary definition graphic",
        "Create a map pin location indicator bug",
        "Generate a timeline progression graphic for a history show",
        "Create an animated pie chart for statistical data",
        "Generate a 'Myth vs Fact' split-screen comparison",
        "Create a subtitled translation lower third with a semi-transparent black background"
    ],
    "Corporate & Presentations": [
        "Generate a corporate webinar speaker nameplate with company logo placeholder",
        "Create a Q&A session 'Submit your questions' lower third",
        "Generate a quarterly earnings report bulleted list graphic",
        "Create a CEO keynote presentation title slide graphic",
        "Generate a Zoom/Teams style multi-participant grid border overlay",
        "Create an agenda/schedule sidebar for a virtual conference",
        "Generate a live polling results donut chart",
        "Create a 'Thank You for Attending' end screen graphic",
        "Generate a corporate sponsor logo wall full-screen graphic",
        "Create a break timer graphic for a corporate retreat stream"
    ],
    "Weather & Emergency": [
        "Generate a severe thunderstorm warning scrolling ticker",
        "Create a hurricane category and wind speed sidebar graphic",
        "Generate a school closing list full-screen scrolling graphic",
        "Create an emergency broadcast system alert full-screen graphic",
        "Generate a 7-day extended forecast grid",
        "Create a UV index and allergy alert corner bug",
        "Generate a traffic camera location and congestion level lower third",
        "Create a current temperature and humidity top-left bug",
        "Generate a radar map legend overlay graphic",
        "Create a heat advisory warning full-screen banner"
    ],
    "Religious & Community Broadcasting": [
        "Generate a church livestream sermon title and scripture reference lower third",
        "Create a 'To Donate' text-to-give instruction graphic",
        "Generate a worship song lyrics lower third with large clear font",
        "Create a community announcements bulleted list",
        "Generate a prayer request hotline lower third",
        "Create an upcoming events calendar sidebar",
        "Generate a guest speaker introduction full-screen graphic",
        "Create a 'Welcome to our Sunday Service' bumper graphic",
        "Generate a charity telethon running total thermometer graphic",
        "Create a volunteer sign-up web address lower third"
    ],
    "Music & Arts": [
        "Generate a classical music concert piece title and composer lower third",
        "Create a theater play act and scene indicator graphic",
        "Generate a live band member name and instrument nameplate",
        "Create a music festival stage schedule sidebar",
        "Generate an art gallery auction lot number and current bid graphic",
        "Create a dance competition score and routine name graphic",
        "Generate an orchestra conductor introduction lower third",
        "Create a poetry reading author and book title graphic",
        "Generate a DJ setlist current track pop-up bug",
        "Create a music chart top 10 countdown full-screen graphic"
    ],
    "Niche Sports & Activities": [
        "Generate a billiards/snooker current break score bug",
        "Create a bowling frame-by-frame scoreboard graphic",
        "Generate a darts leg and sets remaining scoreboard",
        "Create a curling end score and hammer indicator bug",
        "Generate a chess match evaluation bar and clock graphic",
        "Create a poker player hand probability percentage graphic",
        "Generate a rodeo bull riding time and score lower third",
        "Create a drone racing pilot POV overlay with speed telemetry",
        "Generate a fishing tournament total weight leaderboard",
        "Create a spelling bee word and definition full-screen graphic"
    ]
};
